export function getTldFromUrl(url: URL) {
  const host = url.hostname.split('.')
  const tld = host.slice(-2).join('.')

  return tld
}
